<template>
  <div class="other-info-tab px-5 pt-2">
    <div class="re-export-tab__form">
      <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
        <v-row>
          <v-col cols="12" :xs="12" :sm="12" :md="6">
            <AutoComplete
              v-model="accessoryDropdownValue"
              item-text="text"
              :return-object="true"
              :items="accessories"
              :loading="isReExportTabFormLoading || savingExportJob"
              label="Accessories"
            />
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="manufCode"
              :loading="isReExportTabFormLoading || savingExportJob"
              label="Manufacturing Code"
            ></TextField>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <v-textarea
              v-model="accessoriesDescription"
              filled
              rows="5"
              :loading="isReExportTabFormLoading || savingExportJob"
              :disabled="!isAccessoryDescription"
              label="Accessories Description"
            ></v-textarea>
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <AutoComplete
              :items="countries"
              item-text="name"
              :return-object="true"
              :loading="isReExportTabFormLoading || savingExportJob"
              v-model="sourceStateDropdownValue"
              label="Source State"
            />
            <v-row>
              <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
                <AutoComplete
                  v-model="transitCountryDropdownValue"
                  :items="countries"
                  item-text="name"
                  :return-object="true"
                  :loading="isReExportTabFormLoading || savingExportJob"
                  label="Transit Country"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <v-textarea
              v-model="manufAddress"
              filled
              rows="5"
              :loading="isReExportTabFormLoading || savingExportJob"
              label="Manufacturing Address"
            ></v-textarea>
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <AutoComplete
              v-model="manufCityDropdownValue"
              item-text="text"
              :items="cities"
              :return-object="true"
              :loading="isReExportTabFormLoading || savingExportJob"
              label="Manufacturing City"
            />
            <v-row>
              <v-col cols="12" :xs="12" :sm="12" :md="12" :lg="12">
                <AutoComplete
                  v-model="manufCountryDropdownValue"
                  :return-object="true"
                  :items="countries"
                  item-text="name"
                  :loading="isReExportTabFormLoading || savingExportJob"
                  label="Manufacturing Country"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <TextField
              v-model="manufPin"
              :loading="isReExportTabFormLoading || savingExportJob"
              label="Manufacturing Pin"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
              <v-btn width="140" color="info" large class="white--text" @click="$emit('change-tab', 2)">
                <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
                <span class="font-weight-bold fs-15">Previous</span>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
            <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
              <v-btn
                width="140"
                color="button-primary"
                large
                class="white--text"
                @click="passes(saveOtherInfoTabDetails)"
              >
                <span class="font-weight-bold fs-15">Save</span>
              </v-btn>
              <div class="ml-2 mr-2 my-1"></div>
              <v-btn width="140" color="info" large class="white--text" @click="$emit('close-dialog', true)">
                <span class="font-weight-bold fs-15">Next</span>
                <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";
export default {
  name: "OtherInfoTab",
  components: {
    ValidationObserver,
    TextField,
    AutoComplete
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isThirdPartyExport: false,
      isReExportTabFormLoading: false,
      isAccessoryDescription: false
    };
  },
  beforeDestroy() {
    this.makeFieldsNull();
  },
  mounted() {
    this.checkAccessoryStatus();
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    saveOtherInfoTabDetails() {
      const item = { ...this.$store.getters.item };
      this.$store.commit(MT.SET_ITEMS_IN_EXPORT_JOB, item);
      this.saveExportJob();
      this.$emit("close-dialog", true);
    },
    checkAccessoryStatus() {
      const accessoryStatus = this.$store.state.ExportModuleStore.item.accessoryStatus;
      if (accessoryStatus === null) {
        this.$store.commit(MT.SET_ITEM_ACCESSORY_STATUS, { value: "0" });
        return;
      }
    },
    makeFieldsNull() {
      this.isThirdPartyExport = null;
      this.accessory = "";
      this.manufCode = null;
      this.manufAddress = "";
      this.manufCountry = null;
      this.manufCity = null;
      this.manufPin = null;
      this.sourceState = null;
      this.transitCountry = null;
      this.name = null;
      this.ieCode = null;
      this.branchSrNo = null;
      this.gstInType = null;
      this.address = null;
    }
  },
  computed: {
    accessories() {
      return this.$store.getters.accessories;
    },
    countries() {
      return this.$store.getters.countries;
    },
    states() {
      return this.$store.getters.states;
    },
    cities() {
      return this.$store.getters.cities;
    },
    gstInTypes() {
      return this.$store.getters.gstInTypes;
    },
    accessoryDropdownValue: {
      get() {
        const selectedAccessoryStatus = this.accessoryStatus;
        if (selectedAccessoryStatus !== "" && !!selectedAccessoryStatus) {
          return this.accessories.find(type => type.textIdentifier.includes(selectedAccessoryStatus));
        } else {
          return this.accessories.find(type => type.textIdentifier.includes("0"));
        }
      },
      set(accessoryObject) {
        if (accessoryObject.textIdentifier === "1") {
          this.isAccessoryDescription = true;
        } else {
          this.isAccessoryDescription = false;
        }
        this.$store.commit(MT.SET_ITEM_ACCESSORY_STATUS, { value: accessoryObject.textIdentifier });
        this.accessoryStatus = accessoryObject;
      }
    },
    // accessory: {
    //   get() {
    //     if (this.accessoryStatus !== undefined && this.accessoryStatus !== null) {
    //       const accessory = this.accessories.find(accessory => accessory.textIdentifier === this.accessoryStatus);
    //       return accessory !== undefined ? accessory.text : null;
    //     }
    //     return this.accessories[0];
    //   },
    //   set(value) {
    //     this.accessoryStatus = value.textIdentifier;
    //     // yes accessory is present
    //     if (value.textIdentifier === 1) {
    //       this.isAccessoryDescription = true;
    //     } else {
    //       this.isAccessoryDescription = false;
    //     }
    //   }
    // },
    accessoriesDescription: {
      get() {
        return this.$store.state.ExportModuleStore.itemAccess.descriptionAccessories;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ACCESS_DESCRIPTION_ACCESSORIES, { value });
      }
    },
    accessoryStatus: {
      get() {
        const accessoryStatus = this.$store.state.ExportModuleStore.item.accessoryStatus;
        if (accessoryStatus === null) {
          return "0";
        }
        return this.$store.state.ExportModuleStore.item.accessoryStatus;
      },
      set(accessoryObject) {
        this.$store.commit(MT.SET_ITEM_ACCESSORY_STATUS, { value: accessoryObject.textIdentifier });
      }
    },

    manufCode: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerCode;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_CODE, { value });
      }
    },
    manufAddress: {
      get() {
        const itemProducerAddress1 = this.$store.state.ExportModuleStore.item.itemProducerAddress1;
        const itemProducerAddress2 = this.$store.state.ExportModuleStore.item.itemProducerAddress2;
        return [itemProducerAddress1, itemProducerAddress2].join("");
      },
      set(address) {
        if (address.length < 70) {
          this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_ADDRESS1, { value: address.substr(0, address.length) });
        } else if (address.length >= 70 && address.length < 120) {
          this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_ADDRESS1, { value: address.substr(0, 70) });
          this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_ADDRESS2, { value: address.substr(71, address.length) });
        }
        return;
      }
    },
    manufCountryDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerCountryCodeDropdownValue;
      },
      set(manufCountryObject) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_CODE_DROPDOWN_VALUE, { value: manufCountryObject.name });
        this.manufCountry = manufCountryObject.code;
        return;
      }
    },
    manufCountry: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerCountryCode;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_COUNTRY_CODE, { value });
      }
    },
    manufCityDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerCityDropdownValue;
      },
      set(itemProducerCityObject) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_CITY_DROPDOWN_VALUE, { value: itemProducerCityObject.text });
        this.manufCity = itemProducerCityObject.text;
        return;
      }
    },
    manufCity: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerCity;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_CITY, { value });
      }
    },
    manufPin: {
      get() {
        return this.$store.state.ExportModuleStore.item.itemProducerPin;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_ITEM_PRODUCER_PIN, { value });
      }
    },
    sourceStateDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.sourceStateDropdownValue;
      },
      set(sourceStateObject) {
        this.$store.commit(MT.SET_ITEM_SOURCE_STATE_DROPDOWN_VALUE, { value: sourceStateObject.text });
        this.sourceState = sourceStateObject.code;
        return;
      }
    },
    sourceState: {
      get() {
        return this.$store.state.ExportModuleStore.item.sourceState;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_SOURCE_STATE, { value });
      }
    },
    transitCountryDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.item.transitCountryDropdownValue;
      },
      set(transitCountryObject) {
        this.$store.commit(MT.SET_ITEM_TRANSIT_COUNTRY_DROPDOWN_VALUE, { value: transitCountryObject.name });
        this.transitCountry = transitCountryObject.code;
        return;
      }
    },
    transitCountry: {
      get() {
        return this.$store.state.ExportModuleStore.item.transitCountry;
      },
      set(value) {
        this.$store.commit(MT.SET_ITEM_TRANSIT_COUNTRY, { value });
      }
    }
  }
};
</script>
<style lang="scss">
.re-export-tab {
  &__form {
    &__third-party {
      border: solid 2px darkgrey;
      border-radius: 10px;
    }
  }
}
</style>
